import { isTieredVariant } from '@lub0v/santa-utils';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { usePremiumOffer } from '@src/pages/PremiumPage/PremiumOfferProvider';
import { premiumFeatureTier } from '@src/pages/PremiumPage/featureTier';
import { PremiumBadge } from './PremiumBadge';
import { premiumTierName, type PremiumTier } from './tierIdentity';

export function PremiumFeatureBadge({ feature, children }: { feature: string; children?: ReactNode }) {
  const { t, i18n } = useTranslation();
  const offer = usePremiumOffer(feature);
  const tier = isTieredVariant(offer.variant) ? premiumFeatureTier(feature) as PremiumTier | undefined : undefined;
  return <PremiumBadge tier={tier}>{tier ? premiumTierName(tier, i18n.language.startsWith('ru')) : children || t('account.plan.premium')}</PremiumBadge>;
}
